/* Copyright Information: Created by BuyGroup */
import React, { useState, useEffect } from "react";
import { Card, Row, Col, CardBody, Spinner, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
import Breadcrumbs from "../components/common/breadcrumb";
import Select from "react-select";
import { toast } from "react-toastify";
import Moment from "react-moment";
import OrderUpdate from "../OrderManagement/OrderUpdate";
import { supplierOrderList, orderStatus } from "../services/OrderServices";
import dateFormat from "dateformat";
import { Link } from "react-router-dom";
import { generatePdfDocument } from "./SupplierOrderPdf";
const orderStatusList = [
  {
    label: "Pending",
    value: "in_progress",
  },
  {
    label: "To Be Shipped",
    value: "shipping",
  },
  {
    label: "Completed",
    value: "completed",
  },
  {
    label: "Cancelled",
    value: "cancelled",
  },
  {
    label: "Paid",
    value: "paid",
  },
  {
    label: "Payment Failed",
    value: "payment_failed",
  },
  {
    label: "Return Requested",
    value: "return_requested",
  },
  {
    label: "Return Accepted",
    value: "return_accepted",
  },
  {
    label: "Return Declined",
    value: "return_declined",
  },
  {
    label: "Return In Progress",
    value: "return_in_progress",
  },
  {
    label: "Refunded",
    value: "refunded",
  },
  {
    label: "Return Label Sent",
    value: "return_label_sent",
  },
  {
    label: "Order Placed",
    value: "order_placed",
  },
];

const SupplierOrdersList = () => {
  const { ExportCSVButton } = CSVExport;

  /* const SearchBar  responsible for serach */
  const { SearchBar } = Search;

  /* const "orderList" constant store all data of order List*/
  const [orderList, setOrderList] = useState([]);

  /* const "orderList" constant store all data of order List*/
  const [orderListFilter, setOrderListFilter] = useState(orderList);

  /*  const "status" store object of selected option   */
  const [status, setStatus] = useState(null);

  /* const "isloading" constant is responsible for showing loader in order List */
  const [isLoading, setIsLoading] = useState(true);

  /*  const "orderUpdateModal" responsible for order Update Modal open or closed  */
  const [orderUpdateModal, setOrderUpdateModal] = useState(false);

  /* const "isLoadingButton" constant is disable button when data is feaching from api */
  const [isLoadingButton, setIsLoadingButton] = useState(false);

  /* const "rowData"  store select Row data */
  const [rowData, setRowData] = useState({});

  // Modal state for return details
  const [detailsModal, setDetailsModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [modalTitle, setModalTitle] = useState("");

  // Return reasons for better organization
  const returnReasons = [
    { value: "defective", label: "Product is defective or not working" },
    { value: "wrong_item", label: "Wrong item received" },
    { value: "not_as_described", label: "Product not as described" },
    { value: "damaged", label: "Product arrived damaged" },
    { value: "size_issue", label: "Size doesn't fit" },
    { value: "quality_issue", label: "Quality not as expected" },
    { value: "changed_mind", label: "Changed my mind" },
    { value: "duplicate_order", label: "Duplicate order" },
    { value: "missing_parts", label: "Missing parts or accessories" },
    { value: "expired", label: "Product expired or near expiry" },
    { value: "other", label: "Other reason" }
  ];

  // Define the status flow - what statuses can transition to what
  const getAvailableStatuses = (currentStatus) => {
    const statusFlow = {
      // Regular order flow
      in_progress: ["shipping", "cancelled", "payment_failed"],
      shipping: ["completed", "cancelled", "payment_failed"],
      order_placed: ["completed", "cancelled", "shipping"],
      completed: [],
      cancelled: [],
      paid: ["completed", "cancelled", "shipping"],
      payment_failed: ["cancelled", "in_progress"],
      
      // Return flow
      return_requested: ["return_accepted", "return_declined"],
      return_accepted: ["return_in_progress", "return_label_sent", "refunded"],
      return_declined: [],
      return_in_progress: ["refunded", "return_label_sent"],
      refunded: [],
      return_label_sent: ["refunded"],
      order_placed: ["completed", "cancelled", "shipping"]
    };

    return statusFlow[currentStatus] || [];
  };

  // Get status display name
  const getStatusDisplayName = (status) => {
    const statusNames = {
      in_progress: "In Progress",
      shipping: "To Be Shipped",
      completed: "Completed",
      cancelled: "Cancelled",
      paid: "Paid",
      payment_failed: "Payment Failed",
      return_requested: "Return Requested",
      return_accepted: "Return Accepted",
      return_declined: "Return Declined",
      return_in_progress: "Return In Progress",
      refunded: "Refunded",
      return_label_sent: "Return Label Sent",
      order_placed: "Order Placed"
    };
    return statusNames[status] || status;
  };

  const dateFormatter = (cell) => {
    return <Moment format="MM/DD/YYYY h:mm a">{cell}</Moment>;
  };

  function priceFormatter(cell, row) {
    let myNumber = cell;
    let myNumberWithTwoDecimalPlaces = parseFloat(myNumber).toFixed(2);
    return myNumberWithTwoDecimalPlaces;
  }
  const totalFormatter = (cell,row) => {
    console.log("row",row.rate)
    console.log("row",row.quantity)
    console.log("row",row.tax_value)
    console.log("row",row.shipping)
    let myNumber =parseFloat(
      row.rate * row.quantity +
        parseInt(row.tax_value) +
        parseInt(row.shipping)
    ).toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
    
    return "$" + myNumber;
  };

  const orderImage = (cell) => {
    return (
      <div className="product_thumb">
        <img alt="Not Found" className="img-responsive" src={cell} />
      </div>
    );
  };

  const nameFormatter = (cell, row) => (
    <Link
      to={{
        pathname: `/app/supplier/memeber/${row.order_line_id}`,
      }}
    >
      <span>{cell}</span>
    </Link>
  );

  const groupFormatter = (cell, row) => (
    <Link to={{ pathname: "/app/groups/view/" + row.buy_group_id }}>
      <span>{cell}</span>
    </Link>
  );

  const columns = [
    {
      dataField: "path",
      text: "Image",
      csvExport: false,
      formatter: orderImage,
    },
    {
      dataField: "group_name",
      text: "Group Name",
      formatter: groupFormatter,
    },
    {
      dataField: "customer_name",
      text: "Name",
      headerAlign: "right",
      align: "right",
      formatter: nameFormatter,
    },
    {
      dataField: "start_date",
      text: "Start Date",
      formatter: dateFormatter,
      csvFormatter: (cell, row, rowIndex) =>
        dateFormat(cell, "mm/dd/yyyy  h:MM TT"),
    },
    {
      dataField: "end_date",
      text: "End Date",
      formatter: dateFormatter,
      csvFormatter: (cell, row, rowIndex) =>
        dateFormat(cell, "mm/dd/yyyy  h:MM TT"),
    },
    {
      dataField: "quantity",
      text: "Quantity",
    },
    {
      dataField: "rate",
      text: "Rate",
      formatter: (cell,row,)=> priceFormatter(cell, row),
    },
    {
      dataField: "total",
      text: "Total",
      formatter: (cell,row,)=> totalFormatter(cell, row),
    },

    {
      dataField: "street",
      text: "Street",
      hidden: true,
    },
    {
      dataField: "city",
      text: "City",
      hidden: true,
    },
    {
      dataField: "state",
      text: "State",
      hidden: true,
    },
    {
      dataField: "country",
      text: "Country",
      hidden: true,
    },
    {
      dataField: "status",
      text: "Status",
      formatter: (cell, row) => {
        const availableTransitions = getAvailableStatuses(cell);
        const transitionText = availableTransitions.length > 0 
          ? `Available transitions: ${availableTransitions.map(s => getStatusDisplayName(s)).join(', ')}`
          : 'No further transitions available';
        
        return (
          <div className={`status_column ${cell}`}>
            <span title={transitionText}>{getStatusDisplayName(cell)}</span>
            {cell === "return_requested" && (row.return_reason || row.return_note) && (
              <i 
                className="fa fa-info-circle ml-1" 
                style={{ cursor: 'pointer', color: '#ff6b6b', fontSize: '16px' }}
                onClick={() => handleReturnRequestedModal(row)}
                title={row.return_reason || "Click to view return details"}
              ></i>
            )}
          </div>
        );
      },
    },
    {
      dataField: "",
      text: "",
      formatter: (cell, orderRow) => (
        <div>
          <span
            className="inline-block pointer-cursor"
            onClick={() => handleModalOpen(orderRow)}
          >
            <i
              className="fa fa-pencil"
              style={{
                width: 35,
                fontSize: 20,
                paddingLeft: 11,
                color: "#e4566e",
              }}
            ></i>
          </span>
        </div>
      ),
      headerAlign: "right",
      align: "right",
      csvExport: false,
    },
  ];

  useEffect(() => {
    getOrder(); // Get all orders
  }, []);

  /* it will give order list of respective supplier */
  const getOrder = () => {
    setIsLoading(true);
    const getuserData = window.localStorage.getItem("user");
    const userData = JSON.parse(getuserData);
    supplierOrderList(userData.supplier_id)
      .then((res) => {
        if (res.status === 200) {
          setOrderList(res.data);
          setOrderListFilter(res.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error.data?.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsLoading(false);
      });
  };

  /**
   * Function handleChangeStatus filter order data
   * @param  {selectedOption} selectedOption data Object
   */
  const handleChangeStatus = (selectedOption) => {
    if (selectedOption !== null) {
      setStatus(selectedOption);
      let filterOrderList = orderListFilter.filter((order) => {
        if (order.status === selectedOption.value) {
          return order;
        }
      });
      setOrderList(filterOrderList);
    } else {
      setStatus(null);
      getOrder();
    }
  };

  /**it will Open order Status Change Modal
   * @param  {values} values data Object
   */
  const handleModalOpen = (orderRow) => {
    setRowData(orderRow);
    setOrderUpdateModal(true);
  };

  /**
   * Function to open return requested modal for return reason and note
   * @param {object} orderRow order data
   */
  const handleReturnRequestedModal = (orderRow) => {
    setModalTitle("Return Request Details");
    setModalData({
      return_reason: orderRow.return_reason,
      return_note: orderRow.return_note,
      status: orderRow.status
    });
    setDetailsModal(true);
  };

  /**
   * Function to close details modal
   */
  const closeDetailsModal = () => {
    setDetailsModal(false);
    setModalData({});
    setModalTitle("");
  };

  /** it Will update the Status of order
   * @param  {values} values data Object
   */
  const updateOrder = (values, actions) => {
    setIsLoadingButton(true);
    orderStatus(values)
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.message, {
            autoClose: 3000,
            hideProgressBar: true,
          });
          setIsLoadingButton(false);
          setOrderUpdateModal(false);
          getOrder();
        }
      })
      .catch((error) => {
        toast.error(error.data.message, {
          autoClose: 3000,
          hideProgressBar: true,
        });
        setIsLoadingButton(false);
      });
  };

  /**  formate phone Number in US formate
   * @param phoneNumberString number
   */
  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? "+1 " : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return null;
  };
  return (
    <>
      <Breadcrumbs title="Orders" parent="" subtitle="Orders Admin Panel" />
      <div className="container-fluid">
        <Row className="row">
          <Col md="12">
            <React.Fragment>
              <Row>
                <Col lg="12" md="12">
                  <Card className="card-box">
                    <div className="card-header">
                      <div className="d-flex align-items-center justify-content-between">
                        <h5>Orders</h5>
                      </div>
                    </div>
                    <CardBody>
                      <ToolkitProvider
                        keyField="order_line_id"
                        data={orderList}
                        columns={columns}
                        search
                        exportCSV
                      >
                        {(props) => (
                          <div>
                            <div className="table_SearchBar d-flex align-items-center mb-3 flex-wrap">
                              <div
                                className="select_dropdown"
                                style={{ flex: 1 }}
                              >
                                <ul className="d-flex flex-wrap">
                                  <li className="mr-4">
                                    <div className="form-group mb-0">
                                      <Select
                                        value={status}
                                        onChange={handleChangeStatus}
                                        options={orderStatusList}
                                        isClearable={true}
                                        placeholder="Filter By Status"
                                      />
                                    </div>
                                  </li>
                                </ul>
                              </div>
                              <div
                                className="product_search"
                                style={{ marginRight: "15px" }}
                              >
                                <SearchBar
                                  {...props.searchProps}
                                  placeholder="Search Order"
                                />
                              </div>

                              <div>
                                {isLoading !== true && (
                                  <ExportCSVButton
                                    {...props.csvProps}
                                    className="export_Button"
                                  >
                                    <i className="fa fa-download mr-2"></i>
                                    Download CSV
                                  </ExportCSVButton>
                                )}
                              </div>

                              {/* <Button
                                  type="button"
                                  color="secondary"
                                  data-toggle="modal"
                                  data-original-title="Download pdf"
                                  style={{width:200}}
                                  onClick={() =>
                                    generatePdfDocument(orderList,formatPhoneNumber)
                                  }
                                 
                                >
                                  Download Pdf
                               </Button> */}
                            </div>

                            {isLoading ? (
                              <div className="custom-loader">
                                <Spinner animation="border" />
                              </div>
                            ) : (
                              <BootstrapTable
                                {...props.baseProps}
                                striped
                                hover
                                condensed
                                noDataIndication={"No orders found"}
                                bordered={false}
                                pagination={paginationFactory({
                                  sizePerPage: 10,
                                  showTotal: true,
                                  hideSizePerPage: true,
                                })}
                                rowClasses="row-hover pointer-cursor"
                              />
                            )}
                          </div>
                        )}
                      </ToolkitProvider>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </React.Fragment>
          </Col>
        </Row>
      </div>
      {orderUpdateModal && (
        <OrderUpdate
          orderUpdateModal={orderUpdateModal}
          onSubmit={updateOrder}
          isLoadingButton={isLoadingButton}
          rowData={rowData}
          handleModalClose={() => setOrderUpdateModal(false)}
        />
      )}
      
      {/* Return Details Modal */}
      <Modal isOpen={detailsModal} toggle={closeDetailsModal} size="lg" style={{ maxHeight: '90vh' }}>
        <ModalHeader toggle={closeDetailsModal}>
          {modalTitle}
        </ModalHeader>
        <ModalBody style={{ maxHeight: 'calc(90vh - 140px)', overflow: 'auto' }}>
          {modalData.return_reason && (
            <div className="mb-4">
              <h6>Return Reason:</h6>
              <p className="text-warning">
                {returnReasons.find(reason => reason.value === modalData.return_reason)?.label || modalData.return_reason}
              </p>
            </div>
          )}
          {modalData.return_note && (
            <div className="mb-4">
              <h6>Return Note:</h6>
              <p className="text-muted">{modalData.return_note}</p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={closeDetailsModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default SupplierOrdersList;
/* Copyright Information: Created by BuyGroup */
